import { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { cn } from "~/lib/utils";

/**
 * Shared active/inactive styling for the project / dataset / agent section
 * sidebar links. Padding is intentionally omitted so callers can size rows to
 * their sidebar (the section sidebars use `px-3 py-2`; the project rail is more
 * compact). Pass the padding via `className`.
 */
export const sectionNavLinkClassName = ({ isActive }: { isActive: boolean }, className?: string) =>
  cn(
    "flex items-center gap-2.5 rounded-md text-sm font-medium transition-colors hover:bg-black/[0.06] hover:text-foreground focus-visible:outline-none dark:hover:bg-white/[0.08]",
    isActive ? "bg-black/[0.06] text-foreground dark:bg-white/[0.08]" : "text-muted-foreground",
    className
  );

interface SectionNavLinkProps {
  to: string;
  icon: ReactNode;
  label: ReactNode;
  end?: boolean;
  badge?: number;
  // Extra classes (default padding is `px-3 py-2` when omitted).
  className?: string;
}

export const SectionNavLink = ({
  to,
  icon,
  label,
  end,
  badge,
  className = "px-3 py-2",
}: SectionNavLinkProps) => (
  <NavLink to={to} end={end} className={(state) => sectionNavLinkClassName(state, className)}>
    <span className="shrink-0">{icon}</span>
    <span className="flex-1">{label}</span>
    {!!badge && (
      <span className="rounded-full bg-muted px-1.5 text-xs tabular-nums text-muted-foreground">
        {badge}
      </span>
    )}
  </NavLink>
);
